import Index from './Index.vue';

export default {
  path: 'acabamentos',
  name: 'produto-acabamento',
  component: Index,
};
